import actionTypes from '../constants/action-types';

const updateIntegrations = (integrations) => ({
  type: actionTypes.UPDATE_INTEGRATIONS,
  payload: {
    integrations,
  },
});

export default updateIntegrations;
